import { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "./api";

export function useApi(url) {
  const [state, setState] = useState({ data: null, loading: true, error: null });

  const load = useCallback(
    async (silent = false) => {
      if (!url) {
        return;
      }
      if (!silent) {
        setState((s) => ({ ...s, loading: true, error: null }));
      }
      try {
        const { data } = await api.get(url);
        setState({ data, loading: false, error: null });
      } catch (e) {
        setState({ data: null, loading: false, error: formatApiError(e) });
      }
    },
    [url]
  );

  useEffect(() => {
    load();
  }, [load]);

  return { ...state, reload: () => load(true), setData: (data) => setState((s) => ({ ...s, data })) };
}
